import { render, staticRenderFns } from "./pedidosPeriodos.vue?vue&type=template&id=549a55ad&scoped=true"
import script from "./pedidosPeriodos.vue?vue&type=script&lang=js"
export * from "./pedidosPeriodos.vue?vue&type=script&lang=js"
import style0 from "./pedidosPeriodos.vue?vue&type=style&index=0&id=549a55ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a55ad",
  null
  
)

export default component.exports